import React from 'react';

export function navigateInternal(e: React.MouseEvent) {
  const el = e.currentTarget;
  if (!(el instanceof HTMLAnchorElement)) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey) return;
  e.preventDefault();
  window.history.pushState({}, '', el.href);
}
